import React from 'react';
import Popover from 'react-tiny-popover';
import { getPath } from '../../utils/getPath';
import { useState } from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { useEffect } from 'react';

const LoyaltyItem = ({ userLevel, data, isFinalLevel }) => {
    const theme = useTheme();
    const isMD = useMediaQuery(theme.breakpoints.down('md'));
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const { name, level_description, level, points, image_available, image_not_available } = data;
    const isPassedLevel = +level < +userLevel;
    const isCurrentLevel = +level === +userLevel;

    useEffect(() => {
        setIsPopoverOpen(false);
    }, [isMD]);

    const getBeforeArrow = () => {
        const index = parseInt(level) + 1;

        switch (index) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 10:
            case 12:
            case 14:
                return getPath('public/img/loyalty/right-up.svg');

            case 8:
            case 16:
                return getPath('public/img/loyalty/up-down.svg');

            default:
                return '';
        }
    };

    const getAfterArrow = () => {
        const index = parseInt(level) + 1;

        switch (index) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 10:
            case 12:
            case 14:
            case 16:
                return getPath('public/img/loyalty/right-down.svg');

            default:
                return '';
        }
    };

    return (
        <div
            className={`loyalty-item item-${parseInt(level) + 1}${isPassedLevel || isCurrentLevel ? ' loyalty-item--active' : ''}${
                isCurrentLevel ? ' loyalty-item--current-level' : ''
            }${isFinalLevel ? ' loyalty-item--final' : ''}`}
        >
            {!isMD && (
                <div className="loyalty-item__before-arrow">
                    <img src={getBeforeArrow()} alt="" />
                </div>
            )}
            <div className="loyalty-item__col">
                <div className="loyalty-item__icon">
                    <img src={isPassedLevel || isCurrentLevel ? image_not_available : image_available} alt="" className="sprite-icon" />
                </div>
                <div className="loyalty-item__info">
                    <div className="loyalty-item__title">{name}</div>
                    <div className="loyalty-item__desc">{points} баллов</div>
                </div>
            </div>
            <div className="loyalty-item__col">
                {isMD ? (
                    <div className="loyalty-item__more-btn" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                        <img src={getPath('public/img/loyalty/info.svg')} alt="" className="sprite-icon" />
                    </div>
                ) : (
                    <Popover
                        isOpen={isPopoverOpen}
                        position={['bottom', 'center']}
                        padding={10}
                        disableReposition
                        onClickOutside={() => setIsPopoverOpen(false)}
                        content={() => (
                            <div className="loyalty-item__more">
                                <div className="loyalty-item__more-title">Вы {name}!</div>
                                <div className="loyalty-item__more-content">{level_description}</div>
                            </div>
                        )}
                    >
                        <div
                            className="loyalty-item__more-btn"
                            onMouseEnter={() => setIsPopoverOpen(true)}
                            onMouseLeave={() => setIsPopoverOpen(false)}
                        >
                            <img src={getPath('public/img/loyalty/info.svg')} alt="" className="sprite-icon" />
                        </div>
                    </Popover>
                )}

                {isCurrentLevel && <div className="loyalty-item__label">ваш уровень</div>}
            </div>

            {isMD && (
                <div className={`loyalty-item__more${isPopoverOpen ? ' show' : ''}`}>
                    <div className="loyalty-item__more-title">Вы {name}!</div>
                    <div className="loyalty-item__more-content">{level_description}</div>
                </div>
            )}
            {!isMD && (
                <div className="loyalty-item__after-arrow">
                    <img src={getAfterArrow()} alt="" />
                </div>
            )}
        </div>
    );
};

export default LoyaltyItem;
